import { ChangePasswordModel } from '@shared/models/ChangePasswordModel';
import { ApiService } from '@shared/services';

export class AccountService extends ApiService {
  constructor() {
    super('/account');
  }

  accountChangePassword(params: ChangePasswordModel) {
    return this.post(
      'Setting/changePassword',
      params,
    );
  }
}
